export enum LogLevel {
  Error,
  Warn,
  Debug,
  Info,
  Log,
}
